export enum OrganizationLicenseStatusEnum {
  Unlicensed = 'UNLICENSED',
  Trialing = 'TRIALING',

  TrialEnded = 'TRIAL_ENDED',
  Active = 'ACTIVE',

  Suspended = 'SUSPENDED',
}